import React, { Component } from 'react'
import Footer from '../footer/footer'
import data from '../../mock/blog-mock.json'
import BookMarkList from '../atoms/bookmark-list.js'
import FooterPostContent from '../atoms/footer-post-content.js'
import SearchPost from '../atoms/search-post.js'
import RecentPosts from '../blog/recent-posts.js'

export default class Post extends Component {
  constructor () {
    super()

    this.requestRecentPost = this.requestRecentPost.bind(this)
    this.state = {
      data: [],
      selectedPost: []
    }
  }

  componentWillMount () {
    this.setState({
      data: data,
      selectedPost: this.props.match.params.id
    })
  }

  setPost () {
    const data = this.state.data
    const selectedPost = this.state.selectedPost

    data.forEach((resp) => {
      if (resp.index === selectedPost) {
        return this.thePost = resp
      }
    })
  }

  requestRecentPost (post) {
    this.setState({
      selectedPost: post
    })

    window.scroll(0, 0)
  }

  renderPost (post, index) {
    const admin = `isAdmin ${post.admin}`
    return (
      <article className="postContainer squad clear">
        <nav className="clear">
          <div className="infoSection">
            <span 
              className="pictureAuthor"
              style={{backgroundImage: `url(/imgs/picture.jpg)`}}>
            </span>
            <span className="authorName">{post.author}</span>
            <span className={admin}><i className="fa fa-chess-king"></i></span>
            <span className="date">{post.month} {post.day}</span>
            <span className="timeToRead">{post.timeToRead} minutos para ler</span>
          </div>
          <div className="menuRight">
            <BookMarkList />
          </div>
        </nav>
        <h2 className="title">{post.title}</h2>
        <h3 className="subtitle">{post.subtitle}</h3>
        <img className="thumbnail" src={`/imgs/${post.img}`} alt="thumb" />
        <div className="textRendering">
          <p dangerouslySetInnerHTML={{__html: post.text}} />
        </div>
        <FooterPostContent />
        <div className="clear">
          <span className="views left">{post.views} visualizações</span>
          <span className="like right"><i className="fa fa-heart"></i></span>
        </div>
      </article>
    )
  }

  render() {
    this.setPost()

    const post = this.thePost
    const data = this.state.data

    return (
      <div className="fullHeight">
        <section id="Post" className="clear">
          <header>
            <nav className="squad clear">
              <a html="" className="back post-link-color">
                <i className="fa fa-angle-double-left"></i> All Posts
              </a>
              <div className="rightSide">
                <a href="" className="button register post-link-color">
                  Login / Registre-se
                </a>
                <a href="" className="members"><i className="fa fa-users"></i></a>
                <SearchPost />
              </div>
            </nav>
          </header>
          {this.renderPost(post)}
          <RecentPosts recentPost={data} requestRecentPost={this.requestRecentPost} />
        </section>
      <Footer />
      </div>
    )
  }

  componentDidMount () {
    window.scroll(0, 0)
  }
}



// WEBPACK FOOTER //
// ./src/components/blog/post.js